import React from 'react';
import CompetitionMatchday from 'app/components/matchCalendar/CompetitionMatchday';
export default function CompetitionMatchdayList(_ref) {
  let {
    data
  } = _ref;
  return /*#__PURE__*/React.createElement(React.Fragment, null, data.map(competitionGroup => /*#__PURE__*/React.createElement(CompetitionMatchday, {
    key: competitionGroup.competition.id,
    data: competitionGroup
  })));
}